import {
    AUTHENTICATING_SALESFORCE_SANDBOX_REQUEST, AUTHENTICATING_SALESFORCE_SANDBOX_SUCCEDDED, AUTHENTICATING_SALESFORCE_SANDBOX_FAILED,
    UPDATING_SALESFORCE_SANDBOX_REQUEST, UPDATING_SALESFORCE_SANDBOX_SUCCEDDED, UPDATING_SALESFORCE_SANDBOX_FAILED,
    FETCHING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST, FETCHING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED, FETCHING_SALESFORCE_SANDBOX_INTEGRATION_FAILED
} from '../../actions/actionTypes.jsx';
import { CHANGING_PRIMARY_CONFIGURATION_SUCCEEDED, 
    DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_FAILED, 
    DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST,
    DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED, 
    FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_SUCCEEDED, 
    OVERIDING_PRIMARY_EVENTS, 
    OVERIDING_PRIMARY_EVENTS_FAILED, 
    OVERIDING_PRIMARY_EVENTS_SUCCEEDED } from '../../actions/actionTypes';
import _ from 'lodash';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  authentication: {
    authenticating: false,
    error: null
  },
  deletion: {
    removing: false,
    error: null
  }
};

function salesforceSandboxReducer(state = initialState, action) {
  switch (action.type) {
    case AUTHENTICATING_SALESFORCE_SANDBOX_REQUEST:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: true,
          error: null
        }
      })
    case AUTHENTICATING_SALESFORCE_SANDBOX_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: null
        }
      })
    case AUTHENTICATING_SALESFORCE_SANDBOX_FAILED:
      return Object.assign({}, state, {
        ...state,
        authentication: {
          authenticating: false,
          error: action.payload
        }
      }) 
    case UPDATING_SALESFORCE_SANDBOX_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_SALESFORCE_SANDBOX_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_SALESFORCE_SANDBOX_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })
      case FETCHING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST:
        return Object.assign({}, state, {
          ...state,
          changes: {
            ...state.changes,
            loading: true
          }
        }) 
      case FETCHING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED:
        let primaryIntegration = {}
        let primaryInstanceOverride = {}
        if(_.get(action,"payload.primaryIntegration")){
          primaryIntegration = _.get(action,"payload.primaryIntegration")
          primaryIntegration["state"] = _.get(action,"payload.primaryIntegration.state")
          primaryInstanceOverride = _.get(action,"payload.configuration")
          primaryInstanceOverride["state"] = _.get(action,"payload.state")
        }
        else{
          primaryIntegration = _.get(action,"payload")
          primaryIntegration["state"] = _.get(action,"payload.state")
        }
        return Object.assign({}, state, {
          ...state,
          changes: {
            ...state.changes,
            loading: false
          },
          primaryInstanceOverride: {
            configuration : primaryInstanceOverride
          },
          primaryIntegration
        }) 
      case FETCHING_SALESFORCE_SANDBOX_INTEGRATION_FAILED:
        return Object.assign({}, state, {
          ...state,
          changes: {
            ...state.changes,
            loading: false
          }
        })  
      case DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_REQUEST:
        return Object.assign({}, state, {
          ...state,
          deletion: {
            error: null,
            removing: true
          }
        })  
      case DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_FAILED:
        return Object.assign({}, state, {
          ...state,
          deletion: {
            removing: false,
            error: action.payload
          }
        })
      case DEACTIVATING_SALESFORCE_SANDBOX_INTEGRATION_SUCCEDDED:
        return Object.assign({}, state, {
          ...state,
          deletion: {
            error: null,
            removing: false,
            success: true
          }
        })
    
      case OVERIDING_PRIMARY_EVENTS:
        return Object.assign({}, state, {
          ...state,
          updatingPrimaryOverrideEvents: {
            error: null,
            updating: true
          }
        })  
      case OVERIDING_PRIMARY_EVENTS_SUCCEEDED:
        return Object.assign({}, state, {
          ...state,
          updatingPrimaryOverrideEvents: {
            error: null,
            updating: false,
            success: true
          }
        })
      case OVERIDING_PRIMARY_EVENTS_FAILED:
        return Object.assign({}, state, {
          ...state,
          updatingPrimaryOverrideEvents: {
            updating: false,
            error: action.payload
          }
        })
      case FETCHING_TOTAL_SALESFORCE_INTEGRATIONS_SUCCEEDED:
        return Object.assign({}, state, {
          ...state,
          totalSalesforceIntegrations: action.payload
        })
       
    default:
      return state;
  }
}

export { salesforceSandboxReducer };